// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15 12H19.5L12 22L4.5 12H9V2H15V12Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-arrow-triangle-down-filled')
export default class ArrowTriangleDownFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'arrow-triangle-down-filled',
    }
  }
}
